import { C } from '../landing.theme'
import { Ic } from '../ui/Ic'
import { Logo } from '../ui/Logo'
import { useIsPhone } from '../ui/useIsPhone'

const FTR_COLS = [
  {
    title: 'СЕРВИС',
    items: [
      { label:'Создать проект', href:'/app' },
      { label:'Возможности',    href:'#features' },
      { label:'Как работает',   href:'#how' },
      { label:'Проекты',        href:'#gallery' },
    ],
  },
  {
    title: 'КОМПАНИЯ',
    items: [
      { label:'О нас',          href:'#about' },
      { label:'Вопросы',        href:'#faq' },
      { label:'Наши бренды',    href:'#about' },
      { label:'Личный кабинет', href:'/dashboard' },
    ],
  },
  {
    title: 'КОНТАКТЫ',
    items: [
      { label:'welland.info@mail.ru', href:'mailto:welland.info@mail.ru' },
      { label:'+7 (777) 229-62-25',   href:'tel:+77772296225', isPhone:true },
      { label:'Алматы, Казахстан',    href:null },
      { label:'WhatsApp',             href:'https://wa.me/77772296225' },
    ],
  },
]

export default function Footer() {
  const isPhone = useIsPhone()
  const lnkStyle = { fontSize:13.5, color:C.s3, marginBottom:10, display:'block', transition:'color .2s', cursor:'pointer', textDecoration:'none' }
  const lnkHover = { onMouseEnter: e => { e.currentTarget.style.color = '#fff' }, onMouseLeave: e => { e.currentTarget.style.color = C.s3 } }
  return (
    <footer style={{ background:C.bg0, borderTop:`1px solid ${C.line}`, padding:'52px 0 32px' }}>
      <div className="wrap">
        <div className="ftr-g" style={{ display:'grid', gridTemplateColumns:'1.6fr 1fr 1fr 1fr', gap:40, marginBottom:40 }}>
          <div className="ftr-logo">
            <Logo s={26}/>
            <p style={{ fontSize:14, color:C.s3, marginTop:16, lineHeight:1.7, maxWidth:240 }}>Подбор и поставка оборудования для бассейнов в Казахстане. Работаем с 2019 года.</p>
            <div style={{ display:'flex', alignItems:'center', gap:7, marginTop:14 }}>
              <span style={{ color:C.teal }}><Ic n="pin" s={14}/></span>
              <span style={{ fontSize:13, color:C.s3 }}>Алматы, Казахстан</span>
            </div>
            <div style={{ display:'flex', gap:10, marginTop:16 }}>
              <a href="https://wa.me/77772296225" target="_blank" rel="noopener noreferrer" aria-label="Написать в WhatsApp"
                style={{ width:34, height:34, borderRadius:10, background:'rgba(255,255,255,.05)', border:`1px solid ${C.line}`, display:'flex', alignItems:'center', justifyContent:'center', color:C.s2, transition:'all .2s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.teal; e.currentTarget.style.color = C.tealBright }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = C.line; e.currentTarget.style.color = C.s2 }}>
                <Ic n="wa" s={15}/>
              </a>
              <a href="https://www.instagram.com/welland.kz/" target="_blank" rel="noopener noreferrer" aria-label="Instagram Welland"
                style={{ width:34, height:34, borderRadius:10, background:'rgba(255,255,255,.05)', border:`1px solid ${C.line}`, display:'flex', alignItems:'center', justifyContent:'center', color:C.s2, transition:'all .2s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.teal; e.currentTarget.style.color = C.tealBright }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = C.line; e.currentTarget.style.color = C.s2 }}>
                <Ic n="ig" s={15}/>
              </a>
            </div>
          </div>
          {FTR_COLS.map((col, ci) => (
            <div key={col.title} className={ci === 2 ? 'ftr-contacts' : ''}>
              <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, fontWeight:700, color:C.s3, letterSpacing:'.14em', textTransform:'uppercase', marginBottom:16 }}>{col.title}</div>
              {col.items.map(item => {
                /* Phone number: call on mobile phones, plain text on tablet/desktop */
                if (item.isPhone) {
                  return isPhone
                    ? <a key={item.label} href={item.href} style={lnkStyle} {...lnkHover}>{item.label}</a>
                    : <span key={item.label} style={{ ...lnkStyle, cursor:'default', userSelect:'text' }}>{item.label}</span>
                }
                return item.href
                  ? <a key={item.label} href={item.href} style={lnkStyle} {...lnkHover}>{item.label}</a>
                  : <span key={item.label} style={{ ...lnkStyle, cursor:'default' }}>{item.label}</span>
              })}
            </div>
          ))}
        </div>
        <div className="ftr-bottom" style={{ borderTop:`1px solid ${C.line}`, paddingTop:22 }}>
          <div style={{ fontSize:13, color:C.s3 }}>© 2026 Welland. Все права защищены.</div>
        </div>
      </div>
    </footer>
  )
}
